import Types from "./Types";

const INITIAL_STATE = {
  list: [],
  meta: null,
  selected: null,
  original: null,
  dirty: false,
  loading: false,
  saving: false,
  error: null,
  validationErrors: null,
};

const cloneTemplate = (template) =>
  template ? JSON.parse(JSON.stringify(template)) : null;

export default function whatsappTemplates(state = INITIAL_STATE, action) {
  const { type, payload } = action;

  switch (type) {
    case Types.WHATSAPP_TEMPLATES_LOADING: {
      return { ...state, loading: payload };
    }

    case Types.WHATSAPP_TEMPLATE_SAVING: {
      return { ...state, saving: payload };
    }

    case Types.GET_WHATSAPP_TEMPLATES_SUCCESS: {
      return {
        ...state,
        list: Array.isArray(payload?.templates) ? payload.templates : [],
        meta: payload?.meta ?? null,
        error: null,
      };
    }

    case Types.GET_WHATSAPP_TEMPLATES_FAIL: {
      return {
        ...state,
        error: payload || "Failed to load WhatsApp templates",
      };
    }

    case Types.SELECT_WHATSAPP_TEMPLATE:
    case Types.GET_WHATSAPP_TEMPLATE_SUCCESS: {
      const template = cloneTemplate(payload);
      return {
        ...state,
        selected: template,
        original: cloneTemplate(payload),
        dirty: false,
        error: null,
        validationErrors: null,
      };
    }

    case Types.GET_WHATSAPP_TEMPLATE_FAIL: {
      return {
        ...state,
        error: payload || "Failed to load template",
        selected: null,
        original: null,
        dirty: false,
      };
    }

    case Types.WHATSAPP_TEMPLATE_DRAFT_CHANGE: {
      if (!state.selected) return state;
      return {
        ...state,
        selected: { ...state.selected, ...payload },
        dirty: true,
        validationErrors: null,
      };
    }

    case Types.WHATSAPP_TEMPLATE_RESET_DRAFT: {
      return {
        ...state,
        selected: cloneTemplate(state.original),
        dirty: false,
        validationErrors: null,
        error: null,
      };
    }

    case Types.SAVE_WHATSAPP_TEMPLATE_SUCCESS: {
      const updated = payload;
      const name = updated?.name;
      const list = state.list.map((item) =>
        item?.name === name ? updated : item
      );
      const hasItem = list.some((item) => item?.name === name);
      const nextList = hasItem ? list : [...list, updated];

      return {
        ...state,
        list: nextList,
        selected: cloneTemplate(updated),
        original: cloneTemplate(updated),
        dirty: false,
        error: null,
        validationErrors: null,
      };
    }

    case Types.SAVE_WHATSAPP_TEMPLATE_FAIL: {
      return {
        ...state,
        error: payload?.error || "Failed to save template",
        validationErrors: payload?.validationErrors || null,
      };
    }

    default:
      return state;
  }
}
